module.exports = __webpack_public_path__ + "static/Q2_2025_Announcement_Financial_Results-97862c48e2062594665625c9b2390e23.pdf";